var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaufeLogoBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4608 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #141f29;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M620,500l-416,135v349H0V0h204v404h416V0h204v984h-204v-484Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1270,0h364l320,984h-214l-77-236h-422l-77,236h-214L1270,0ZM1608,576l-155-480h-2l-155,480h312Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2031,590V0h204v598c0,146,80,232,210,232s210-86,210-232V0h204v590c0,254-160,410-414,410s-414-156-414-410Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3075,0h663v172h-459v252h410v172h-410v388h-204V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3918,0h680v172h-476v232h422v172h-422v236h486v172h-690V0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaufeLogoBlack);
export default __webpack_public_path__ + "static/media/haufe-logo-black.221036ba0cf01b2e959bafd0f77c7cde.svg";
export { ForwardRef as ReactComponent };